import { template as template_59b1c8ff84794300aaa8a7ec01cf7619 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { trackedFunction } from 'reactiveweb/function';
import { waitForPromise } from '@ember/test-waiters';
import { t } from 'ember-intl';
import StandardModal from 'eflex/components/standard-modal';
export default class JsonModal extends Component {
    formattedJson = trackedFunction(this, async ()=>{
        const displayed = this.args.displayed;
        const { default: JSONFormatter } = await waitForPromise(import('json-formatter-js'));
        return new JSONFormatter(displayed).render();
    });
    static{
        template_59b1c8ff84794300aaa8a7ec01cf7619(`
    <StandardModal
      class="component-modals-json"
      @onCancel={{@onCancel}}
      @size="xl"
      ...attributes
    as |modal|>
      <modal.header />
      <modal.body>
        {{!-- template-lint-disable no-triple-curlies --}}
        {{{this.formattedJson.value}}}
        {{!-- template-lint-enable no-triple-curlies --}}
      </modal.body>
      <modal.footer as |footer|>
        <footer.close>
          {{t "close"}}
        </footer.close>
      </modal.footer>
    </StandardModal>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
